import React from 'react';
import { Link, Typography } from "@mui/material";
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import DOMPurify from 'dompurify';

export const RPMText = ({ content, priscmicField, variant, elementRenderType, sx = {} }) => {
    // Support both 'content' (WordPress) and 'priscmicField' (Prismic) prop names
    content = content || priscmicField;
    if (!content) return null;

    const defaultSx = {
        color: "text.primary",
        a: {
            color: "text.link",
            cursor: "pointer",
            textDecoration: "underline",
            "&:visited": { color: "text.link_visited" },
            "&:hover": { color: "text.link_hover" },
            transition: "color 0.3s ease-in-out",
        },
        'ul': {
            pl: '2.5rem',
            mb: '0.75rem',
            mt: '0.5rem',
            listStyle: 'none',
        },
        'ol': {
            pl: '1.5rem',
            mb: '0.75rem',
            mt: '0.5rem',
            listStyle: 'none',
            counterReset: 'list-counter',
        },
        'li': {
            mb: '0.5rem',
            position: 'relative',
            pl: '0.25rem',
        },
        'ul > li::before': {
            content: '""',
            position: 'absolute',
            left: '-1.25rem',
            top: '0.4em',
            width: 0,
            height: 0,
            borderTop: '5px solid transparent',
            borderBottom: '5px solid transparent',
            borderLeft: '7px solid',
            borderLeftColor: 'text.primary',
        },
        'ol > li::before': {
            counterIncrement: 'list-counter',
            content: 'counter(list-counter)',
            position: 'absolute',
            left: '-1.5rem',
            color: 'primary.main',
            fontWeight: 700,
        },
    };

    const combinedSx = { ...defaultSx, ...sx };

    const goToAnchor = (anchor) => {
        anchor = anchor.replace('#', '');
        const element = document.getElementById(anchor);
        if (element) {
            element.scrollIntoView({ behavior: "smooth", block: "start", inline: "nearest" });
        }
    };

    const renderContent = () => {
        // If content is an array (like from sliceData.title1)
        if (Array.isArray(content)) {
            const text = content[0]?.text || '';
            const cleanHtml = DOMPurify.sanitize(text);
            
            return (
                <Typography 
                    variant={variant ?? "body1"} 
                    component={elementRenderType ?? "div"} 
                    sx={combinedSx}
                    dangerouslySetInnerHTML={{ __html: cleanHtml }}
                />
            );
        }

        // If content is a string
        if (typeof content === 'string') {
            const cleanHtml = DOMPurify.sanitize(content);
            
            return (
                <Typography 
                    variant={variant ?? "body1"} 
                    component={elementRenderType ?? "div"} 
                    sx={combinedSx}
                    dangerouslySetInnerHTML={{ __html: cleanHtml }}
                />
            );
        }

        // If content is an object with text property
        if (typeof content === 'object' && content.text) {
            const cleanHtml = DOMPurify.sanitize(content.text);
            
            return (
                <Typography 
                    variant={variant ?? "body1"} 
                    component={elementRenderType ?? "div"} 
                    sx={combinedSx}
                    dangerouslySetInnerHTML={{ __html: cleanHtml }}
                />
            );
        }

        return null;
    };

    return <>{renderContent()}</>;
};

export default RPMText;